import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { Button, Empty, Modal, Spin, Statistic, Table, Tag } from "antd";
import * as React from "react";
import {
  getQuestTypeLabel,
  QuestProgressItem,
  QuestStatusRow,
  useGetQuestStatus,
} from "src/hooks/affiliate";

export type QuestStatusModalProps = {
  progress: QuestProgressItem;
};

export const QuestStatusModal = NiceModal.create(({ progress }: QuestStatusModalProps) => {
  const { visible, hide, remove } = useModal();
  const { data, isFetching } = useGetQuestStatus(progress.questUid, progress.userUid);

  const columns = [
    {
      title: "รายการ",
      dataIndex: "label",
      key: "label",
    },
    {
      title: "สถานะ",
      dataIndex: "value",
      key: "value",
      width: 160,
      align: "right" as const,
      render: (v: string, record: QuestStatusRow) => (
        <Tag color={record.ok ? "green" : "default"}>{v}</Tag>
      ),
    },
  ];

  return (
    <Modal
      centered
      width={680}
      visible={visible}
      afterClose={remove}
      onCancel={hide}
      title={`เช็คสถานะ: ${progress.questName}`}
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button type="primary" onClick={hide}>
            ปิด
          </Button>
        </div>
      }
    >
      {isFetching ? (
        <div style={{ textAlign: "center", padding: 32 }}>
          <Spin />
        </div>
      ) : !data ? (
        <Empty description="ไม่มีข้อมูล" />
      ) : (
        <>
          <div style={{ display: "flex", gap: 32, marginBottom: 16 }}>
            <Statistic
              title="ความคืบหน้าหลัก"
              value={`${data.currentValue}/${data.targetValue}`}
              suffix={
                <Tag style={{ marginLeft: 8 }}>{getQuestTypeLabel(data.questType)}</Tag>
              }
            />
            <Statistic
              title={data.summary.label}
              value={data.summary.value ?? "-"}
            />
          </div>

          {data.rows.length === 0 ? (
            <Empty description="ยังไม่มีรายละเอียดย่อย" image={Empty.PRESENTED_IMAGE_SIMPLE} />
          ) : (
            <Table<QuestStatusRow>
              rowKey={(r) => r.label}
              size="small"
              columns={columns}
              dataSource={data.rows}
              pagination={data.rows.length > 10 ? { pageSize: 10 } : false}
            />
          )}

        </>
      )}
    </Modal>
  );
});

export default QuestStatusModal;
